(function () {
  'use strict';
  if (window.__wifeysThreeStrikesLoaded) return;
  window.__wifeysThreeStrikesLoaded = true;
  var endAt = Date.parse('2026-11-11T23:59:59+02:00');
  var clockStarted = false;
  var offerIndex = 0;
  function rotateOffer() {
    if (document.hidden) return;
    offerIndex = 1 - offerIndex;
    document.querySelectorAll('[data-wts-sale-banner]').forEach(function (banner) {
      if (!banner.classList.contains('wts-sale-ended')) {
        banner.classList.toggle('wts-show-shipping', offerIndex === 1);
      }
    });
  }
  function format(value) { return String(value).padStart(2, '0'); }
  function updateCampaign() {
    var timeLeft = Math.max(0, endAt - Date.now());
    var expired = timeLeft <= 0;
    document.documentElement.classList.toggle('wts-ended', expired);
    document.querySelectorAll('[data-wts-sale-banner]').forEach(function (banner) {
      banner.classList.toggle('wts-sale-ended', expired);
      banner.querySelectorAll('[data-wts-sale-only]').forEach(function (el) {
        el.hidden = expired;
      });
    });
    document.querySelectorAll('[data-wts-sale-countdown]').forEach(function (box) {
      box.hidden = expired;
      if (expired) return;
      var secondsLeft = Math.floor(timeLeft / 1000);
      var values = {
        days: Math.floor(secondsLeft / 86400),
        hours: Math.floor(secondsLeft % 86400 / 3600),
        minutes: Math.floor(secondsLeft % 3600 / 60),
        seconds: secondsLeft % 60
      };
      Object.keys(values).forEach(function (key) {
        var el = box.querySelector('[data-wts-' + key + ']');
        if (el) el.textContent = format(values[key]);
      });
    });
  }
  function start() {
    updateCampaign();
    if (clockStarted) return;
    clockStarted = true;
    window.setInterval(updateCampaign, 1000);
    window.setInterval(rotateOffer, 4500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else start();
  document.addEventListener('shopify:section:load', updateCampaign);
})();
